import { controls } from "../../controls";

const rp1022 = {
  label: "Classification of Loans and Advances and Provisioning",
  pageLabel: "Classification of Loans and Advances and Provisioning",
  starting: true,
  url: "rp1022",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),

    
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Classification of Loans and Advances and Provisioning",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "sr_no",
        width: 40
        

      },
      
      {
        Header: "CATEGORY OF CREDIT FACILITY",
        columns: [
          {
            Header: "STSAO",
            accessor: "stsao",
            type:"currency"
            
          },
          {
            Header: "ST(OSAO)",
            accessor: "st_osao",
            type:"currency"
            
          },
          {
            accessor: "CC and OD",
            Header: "cc_and_od",
            type:"currency"
            
          },
          {
            accessor: "Bills",
            Header: "bills",
            type:"currency"
            
          },
          {
            accessor: "Terms Loans",
            Header: "terms_loans",
            type:"currency"
            
          },
          {
            accessor: "Total",
            Header: "total",
            type:"currency"
            
          }
        ]
      },
      {
        Header: "Permitted Deduction",
        columns: [
          {
            Header: "DICGC AND ECGC",
            accessor: "dicgc_and_ecgc",
            type:"currency"
            
          },
          {
            Header: "CGTMSE",
            accessor: "cgtmse",
            type:"currency"
            
          },
          {
            accessor: "srf_cash_margins_etc",
            Header: "SRF Cash Margins Etc.",
            type:"currency"
          },
          
          {
            accessor: "total",
            Header: "Total",
            type:"currency"
            
          }
        ]
      },
      {
        Header: "Net Outstanding ",
        accessor: "net_outstanding",
        width: "*"
        

      },
      {
        Header: "Provision Required ",
        accessor: "provision_required",
        width: "*"
        

      },
      {
        Header: "% OF Provision to be",
        accessor: "%_oF_provision_to_be",
        width: "*"
        

      }
               
    ]
  }
};

export default rp1022;